import React from "react"

class SendReceiptButton extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    href = this.props.table_action.send_receipt_path.replace(/f_id/g, this.props.checkedCheckboxIds)
    return (
      <div className={"btn-group"}>
        <button type="button" className={"btn btn-primary dropdown-toggle "} data-toggle="dropdown" disabled={this.isActionDisabled(this.props.table_action)}>
          {I18n.t('send_receipt')} <span className="caret"></span>
        </button>
        <ul className="dropdown-menu" role="menu">
          <li className="dropdown-item"><a className="modal-iframe" data-fullscreen="true" href={this.props.table_action.print_receipt_path}>{I18n.t('print_receipt')}</a></li>
          <li className="dropdown-item"><a className="modal-iframe" data-fullscreen="true" href={href}>{I18n.t('send_email')}</a></li>
        </ul>
      </div>
    )
  }

  isActionDisabled(table_action) {

    if (this.props.checkboxesChecked.length >= 1 && this.props.table_action.enabled == 'multiple') {
      return false;
    } else if (this.props.checkboxesChecked.length == 1 && this.props.table_action.enabled == 'single') {
      return false;
    } else if (this.props.table_action.enabled == true) {
      return false;
    } else {
      return true;
    }
  }
}

export default SendReceiptButton